import React from 'react';
import { Button } from '@fiverr-private/button';
import { Loader } from '@fiverr-private/feedback';
import { appTranslate } from '../../i18n';
import { useWizardNavigation } from '../../hooks/use-wizard-navigation/useWizardNavigation';

interface WizardNextBtnProps {
    disabled?: boolean;
    hidden?: boolean;
    onClick?: () => void;
    isLoading?: boolean;
}
export const WizardNextBtn = ({ disabled, hidden, onClick, isLoading }: WizardNextBtnProps) => {
    const { currentPath } = useWizardNavigation();

    const isStoreCreationStep = currentPath === 'subscribe';
    const ctaCopy = isStoreCreationStep ? appTranslate('wizard.create_store_next') : appTranslate('wizard.next');

    return (
        <Button disabled={disabled} hidden={hidden} onClick={onClick} fullWidth={{ sm: false, default: true }}>
            {isLoading ? <Loader /> : ctaCopy}
        </Button>
    );
};
